import EventImage from '../../assets/images/event.png';

export const EventIcon = (props: any) => {
  return <img src={EventImage} alt="Event icon" {...props} />;
};
